import React from "react";
import AccountManage from "./AccountManage";
import LanguageSelector from "../../Components/Structural/TopBar/LanguageSelector";
import "./css/style.css";
import translations from "./translations.json";
import { useGetAccountQuery } from "../../store/accountApi";

const Profile = ({ triggerNotification, closeProfile }) => {
  const preferredLanguage = localStorage.getItem("preferredLanguage") || "nl";
  const t =
    translations[preferredLanguage]?.profile || translations["nl"].profile;

  // One cached request, shared across the app
  const {
    data: accountData,
    isLoading,
    isError,
    refetch,
  } = useGetAccountQuery(undefined, {
    // no extra fetches on mount/arg change (we control when to refetch)
    refetchOnMountOrArgChange: false,
  });

  // Optional: notify on error once
  React.useEffect(() => {
    if (isError)
      triggerNotification?.(
        "Fout bij het ophalen van accountgegevens",
        "error"
      );
  }, [isError, triggerNotification]);

  const refetchAccountData = React.useCallback(() => {
    refetch(); // uses the same cached query key
  }, [refetch]);

  if (isLoading) {
    return (
      <div className="profile-page">
        <div className="profile-page__container">
          <p>{t.loading || "Laden..."}</p>
        </div>
      </div>
    );
  }

  if (!accountData) {
    return (
      <div className="profile-page">
        <div className="profile-page__container">
          <p>{t.noAccountData}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="profile-page">
      <div className="profile-page__language-selector">
        <LanguageSelector />
      </div>
      <div className="profile-page__container">
        <AccountManage
          accountData={accountData}
          setAccountData={() => {
            /* no-op; account is source of truth from RTK Query */
          }}
          triggerNotification={triggerNotification}
          refetchAccountData={refetchAccountData}
        />
      </div>
    </div>
  );
};

export default Profile;
